import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

export default function Reveal({
  children,
  className = "",
  delay = 0,
  y = 32,
  once = true,
  amount = 0.3,
}) {
  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y },
        show: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.95, ease: [0.22, 1, 0.36, 1], delay },
        },
      }}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount }}
    >
      {children}
    </motion.div>
  );
}
